/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react'
import { BrowserRouter as Router, Redirect, withRouter, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import PublicRoute from './PublicRoute'
import LoginPage from './LoginPage/LoginPage'
import ExportPage from './ExportPage/ExportPage'
import ErrorPage from './ErrorPage/ErrorPage'
import ValidateSessionPage from './ValidateSessionPage/ValidateSessionPage'
import OktaRedirect from './OktaRedirect/OktaRedirect'
import SubmitForm from './SubmitForm/SubmitForm'
import About from './AboutPage/About'
import DashboardPageManager from './DashboardPage/DashboardManager/DashboardManagerPage'
import DashboardPagePersonal from './DashboardPage/DashboardPersonal'
import AppBanner from '../components/AppBanner/AppBanner'
import { MainWrapper, ContentWrapper } from './App.style'
import ConfirmationPage from './ConfirmationPage/ConfirmationPage'
import ScrollToTop from '../components/ScrollToTop/ScrollToTop'
import { withTracker } from '../components/GATracking/GATracking'

const authState = {
	isAuthenticated: false,
}

const safeToLowerCase = (val) => {
	try {
		return (val == null ? '' : String(val)).toLowerCase()
	} catch (e) {
		return ''
	}
}

const PrivateRoute = ({ component: RouteComponent, ...rest }) => (
	<PublicRoute
		{...rest}
		component={(props) =>
			authState.isAuthenticated ? (
				<RouteComponent {...props} />
			) : (
				<Redirect
					to={{
						// eslint-disable-next-line no-nested-ternary
						pathname:
							RouteComponent === ExportPage
								? 'exportConfirm'
								: RouteComponent === DashboardPagePersonal
								? 'dashboardConfirm'
								: RouteComponent === DashboardPageManager
								? 'dashboardManagerConfirm'
								: RouteComponent === About
								? 'aboutConfirm'
								: '/',
						state: { from: props.location },
					}}
				/>
			)
		}
	/>
)

PrivateRoute.propTypes = {
	component: PropTypes.func.isRequired,
	location: PropTypes.object,
}

class App extends Component {
	constructor(props) {
		super(props)

		this.state = {
			user: {
				accessToken: null,
				name: null,
				email: null,
			},
		}

		this.handleLogin = this.handleLogin.bind(this)
	}

	handleLogin(user, callback) {
		authState.isAuthenticated = true

		const u = user || {}
		let company = 'nike'

		if (Object.prototype.hasOwnProperty.call(u, 'email') && Object.prototype.hasOwnProperty.call(u, 'company')) {
			const email = safeToLowerCase(u.email)
			const userCompany = safeToLowerCase(u.company)
			if (email.indexOf('converse') > -1 || userCompany.indexOf('converse') > -1) {
				company = 'converse'
			}
		} else if (Object.prototype.hasOwnProperty.call(u, 'openIdToken')) {
			try {
				const openIdValues = (u.openIdToken || '').split('.')
				const payload = openIdValues[1]
				const openIdToken = payload ? (JSON.parse(window.atob(payload)) || {}) : {}
				const preferredUsername = safeToLowerCase(openIdToken.preferred_username)
				const tokenCompany = safeToLowerCase(openIdToken.company)
				if (preferredUsername.indexOf('converse') > -1 || tokenCompany.indexOf('converse') > -1) {
					company = 'converse'
				}
			} catch (e) {
				// Malformed token - default to nike
			}
		}
		window.sessionStorage.company = company
		window.sessionStorage.accessToken = u.accessToken
		this.setState(
			{
				user: {
					...this.state.user,
					...u,
				},
			},
			callback
		)
	}

	render() {
		return (
			<MainWrapper>
				<AppBanner userName={this.state.user.name} />
				<ContentWrapper>
					<Switch>
						<PublicRoute exact path='/' component={ValidateSessionPage} onLogin={this.handleLogin} redirectPath='/login' />
						<PublicRoute
							exact
							path='/dashboardConfirm'
							component={ValidateSessionPage}
							onLogin={this.handleLogin}
							redirectPath='/dashboard'
						/>

						<PublicRoute
							exact
							path='/dashboardManagerConfirm'
							component={ValidateSessionPage}
							onLogin={this.handleLogin}
							redirectPath='/manager-dashboard'
						/>
						<PublicRoute
							exact
							path='/aboutConfirm'
							component={ValidateSessionPage}
							onLogin={this.handleLogin}
							redirectPath='/about'
						/>

						<PublicRoute path='/login' component={LoginPage} user={this.state.user} />

						<PublicRoute path='/confirmation' onLogin={this.handleLogin} component={ConfirmationPage} />

						<PublicRoute
							path='/okta-redirect'
							component={OktaRedirect}
							user={this.state.user}
							onLogin={this.handleLogin}
							redirectPath='/login'
						/>

						<PrivateRoute exact path='/submit' component={SubmitForm} user={this.state.user} />

						<PrivateRoute exact path='/about' component={About} user={this.state.user} />

						<PrivateRoute exact path='/dashboard' component={DashboardPagePersonal} user={this.state.user} />

						<PrivateRoute exact path='/manager-dashboard' component={DashboardPageManager} user={this.state.user} />

						<PublicRoute exact path='*' component={ErrorPage} />
					</Switch>
				</ContentWrapper>
			</MainWrapper>
		)
	}
}

App.propTypes = {}

const AppWithTracker = withTracker(App)
const AppWithRouter = withRouter(AppWithTracker)

export default () => (
	<Router>
		<ScrollToTop>
			<AppWithRouter />
		</ScrollToTop>
	</Router>
)



// WEBPACK FOOTER //
// ./src/containers/App.js